<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="ch00_fm10_half1"></a><a id="page_xv"></a><span class="small">BARBARA JORDAN</span></p>
<p class="image"><a id="page_xvi"></a><img alt="image" src="images/f0xvi-01.jpg"/></p>
<p class="figcap">Jordan at her desk during her first term in the Texas Senate. Photo courtesy of Barbara Jordan Archives, Robert James Terry Library, Texas Southern University, Houston.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm10_half1.vue?a78aa78e